/* import __COLOCATED_TEMPLATE__ from './option.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const Option = templateOnlyComponent<Signature>();
export default Option;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::Whatsapp::InsertTemplate::Option': typeof Option;
    'inbox2/command-k/whatsapp/insert-template/option': typeof Option;
  }
}
